// extracted by mini-css-extract-plugin
export default {"hostelContainer":"Hostel_hostelContainer__EwZ8J","hostelTitle":"Hostel_hostelTitle__UQKqj","hostelText":"Hostel_hostelText__s8+1B"};